import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import css_248z from './user-profile-block.scss.js';
import img from '../../../../assets/images/Button-arrow-secondary.svg.js';

class UserProfileBlock extends s {
    constructor() {
        super(...arguments);
        this.name = '';
        this.subtitle = '';
        this.avatarColor = '';
    }
    render() {
        const avatarTemplate = this.avatarUrl
            ? $ `<img class="avatar" src="${this.avatarUrl}" alt="User avatar">`
            : $ `<div class="avatar" style="background:${this.avatarColor}"></div>`;
        return $ `<a class="user-profile-block-link" href="${this.link}" aria-label="${this.subtitle}" title="${this.subtitle}"><div class="${o({ 'user-profile-block': true })}"><div class="user-info">${avatarTemplate}<div class="text"><p class="name">${this.name}</p><p class="subtitle">${this.subtitle}</p></div></div><div class="action"><img class="icon" src="${img}" alt="${this.subtitle}"></div></div></a>`;
    }
}
UserProfileBlock.styles = css_248z;
__decorate([
    e({ type: String })
], UserProfileBlock.prototype, "name", void 0);
__decorate([
    e({ type: String })
], UserProfileBlock.prototype, "subtitle", void 0);
__decorate([
    e({ type: String })
], UserProfileBlock.prototype, "avatarColor", void 0);
__decorate([
    e({ type: String })
], UserProfileBlock.prototype, "avatarUrl", void 0);
__decorate([
    e({ type: String })
], UserProfileBlock.prototype, "link", void 0);
customElements.define('user-profile-block', UserProfileBlock);

export { UserProfileBlock };
